// extracted by mini-css-extract-plugin
module.exports = {"root":"TabNav_root__fIUel","tab":"TabNav_tab__NMm3h","link":"TabNav_link__1JTa8","selectedLink":"TabNav_selectedLink__2aJ2O","disabled":"TabNav_disabled__3Dkqt"};